export const handleDownloadFile = (url: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';

    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  };
